import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Courses from "@/pages/Courses";
import CourseDetail from "@/pages/CourseDetail";
import EnTrade from "@/pages/EnTrade";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Faq from "@/pages/Faq";
import LegalPage from "@/pages/LegalPage";
import Admin from "@/pages/Admin";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
};

const NotFound = () => (
  <main className="container-x py-40 text-center">
    <p className="eyebrow mb-4">404</p>
    <h1 className="text-4xl sm:text-5xl tracking-tight">Page not found.</h1>
    <a href="/" data-testid="notfound-home-link" className="link-arrow inline-flex items-center gap-2 mt-8 text-pine font-medium">
      Return home <span className="arrow">→</span>
    </a>
  </main>
);

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/courses/:slug" element={<CourseDetail />} />
        <Route path="/entrade" element={<EnTrade />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/legal/:page" element={<LegalPage />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
      <Toaster position="bottom-center" toastOptions={{ style: { background: "#10110F", color: "#F7F7F4", border: "1px solid #272925" } }} />
    </BrowserRouter>
  );
}

export default App;
